module.exports = __webpack_public_path__ + "img/samsung-galaxy-s6.63320b54.png";